// The draft text an error is bound to. Most errors carry it as `text`; the aytm-logic upgrade prompt
// keeps its statement under `statement`, because `text` is read as the message by the question-level
// error popup.
export default function errorAnchorText(error) {
  return error.get('text') || error.get('statement') || ''
}
